import {HttpService, ResponseDTO} from '@/shared';
import {GetListLoggingDTO} from '@/shared/dto/logging.dto';
import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
@Service()
export class LoggingService {
  @observable
  private readonly httpService = Container.get(HttpService);

  @action.bound
  public async getListLogging(
    getListLoggingDTO: GetListLoggingDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getListLoggingDTO);
  }
}
